import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import InputText from '../common/input-text'

type InputNumberProps<IFormValues extends FieldValues> = {
    label?: string
    hideLabel?: boolean
    name: Path<IFormValues>
    required?: boolean
    disabled?: boolean
    control: Control<IFormValues, any>
    placeholder?: string
    type?: 'password' | 'text' | 'email'
    className?: string
    wrapperClassName?: string
    dataCy?: string
}

const ControlledInputText = <IFormValues extends FieldValues>({
    label,
    hideLabel,
    required = false,
    name,
    disabled,
    control,
    placeholder,
    type = 'text',
    className,
    wrapperClassName,
    dataCy,
}: InputNumberProps<IFormValues>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <InputText
                    label={label}
                    hideLabel={hideLabel}
                    required={required}
                    disabled={disabled}
                    placeholder={placeholder}
                    error={fieldState.error?.message as any}
                    value={field.value}
                    onChange={(value) => field.onChange(value as any)}
                    type={type}
                    className={className}
                    wrapperClassName={wrapperClassName}
                    dataCy={dataCy}
                ></InputText>
            )}
        />
    )
}

export default ControlledInputText
